<template>
   <div class="course_introduction">
    <div v-if="publisher!=null" class="publisher">
      <p v-html="publisher"></p>
    </div>
    <section class="uploadArea intro">
      <span v-html="purchaseInfo"></span>
      <span v-html="description"></span>
    </section>

    <!-- <section
      v-show="auditionVideosList.length !== 0"
      class="demo"
    >
      <h2>試聽內容</h2>
      <ul>
        <li v-for = "audition_videos in auditionVideosList"
          :key="audition_videos.id"
        >
          <p v-if="isMobile">
            <a
              data-fancybox
              target="_blank"
              v-bind:href="youtube_url+ audition_videos.video"
              class="playBtn">
              播放
            </a>
          </p>

          <p v-if="!isMobile">
            <a
              data-fancybox
              v-bind:href="youtube_url+ audition_videos.video"
              class="playBtn glightbox3">
              播放
            </a>
          </p>

          <p>{{audition_videos.title}}</p>
        </li>
      </ul>
    </section> -->

    <section class="uploadArea">
      <div class="moreOrLess">
        <span v-html="descriptionHtml"></span>
      </div>
    </section>

    <section class="courseTutor">
      <h2>主講人</h2>

      <div class="wrapper">
        <div class="image"><img v-bind:src="authorImgAvatar" ></div>
        <div class="intro">
          <strong>{{ authorTitle }}</strong>
          <div>
            <span v-html="authorDescription"></span>
          </div>

          <div class="multiCourses" v-if="authorChannels.length >0">
            <p><strong>{{ authorTitle }}的其他課程</strong></p>
            <div class="lessons">
              <ul
                v-for="channels in authorChannels"
                :key="channels.id">
                <li>
                  <a :href="'/channel/'+channels.id"> {{channels.title}}</a>
                </li>
              </ul>
            </div >
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
/* eslint-disable no-undef */
// eslint-disable-next-line no-unused-vars
import fancybox from '@/assets/vendor/fancybox-master/jquery.fancybox.min.js'
// eslint-disable-next-line no-unused-vars
import readmore from '@/assets/vendor/readmore/readmore.min.js'

import { mapState } from 'vuex'

export default {
  name: 'CourseIntroduction',
  props: {
    publisher: {
      type: String,
      default: ''
    },
    purchaseInfo: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    auditionVideosList: {
      type: Array,
      default: () => []
    },
    descriptionHtml: {
      type: String,
      default: ''
    },
    authorImgAvatar: {
      type: String,
      default: ''
    },
    authorTitle: {
      type: String,
      default: ''
    },
    authorDescription: {
      type: String,
      default: ''
    },
    authorChannels: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile
    })
  },
  data () {
    return {
      youtube_url: 'https://www.youtube.com/watch?v='
    }
  },
  mounted () {
    $('.moreOrLess').readmore({
      moreLink: '<a class="readMore" href="#">顯示更多</a>',
      lessLink: '<a href="#">顯示更少</a>',
      collapsedHeight: 600,
      afterToggle: function (trigger, element, expanded) {
        if (!expanded) {
          // The "Close" link was clicked
          $('html, body').animate(
            { scrollTop: element.offset().top },
            { duration: 100 }
          )
        }
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.course_introduction {
  margin-bottom: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Course/components/CourseIntroduction.vue